<h2 matDialogTitle mat-dialog-draggable-title>
  {{'title.document_download' | translate}}
  <button type="button" class="close" aria-label="Close" cdkFocusInitial (click)="closeDialog()">
    <span aria-hidden="true">&times;</span>
  </button>
</h2>
<mat-divider></mat-divider>
<mat-dialog-content>
  <form [formGroup]="formValue" style="font-size: 16px;">
    <div class="pt-3">
      <div class="w-100 d-flex item-center mb-2">
        <span style="overflow: hidden;
          max-width: 80%;
          white-space: nowrap;
          text-overflow: ellipsis;
          display: inline-block;"
           >{{ "document_download.template_from" | translate }}:
          <span [matTooltip]="data.name" class="font-weight-bold"> {{data.name}}</span></span>
        <span [matTooltip]="'document_template.tooltip_preview' | translate">
          <mat-icon class="ml-4 text-danger"
          style="cursor: pointer;" (click)="preview(data)">visibility
        </mat-icon></span>
      </div>
      <div>
        <mat-form-field class="w-100">
          <mat-label>{{'document_download.template_name' | translate}}</mat-label>
          <input type="text" matInput formControlName="name" required maxlength="200" (focusout)="focusOut('name')">
          <mat-error *ngIf="formValue.controls.name.hasError('required')">
            {{'document_download.name_required' | translate}}
          </mat-error>
        </mat-form-field>
      </div>
      <mat-form-field class="w-100">
        <mat-label>{{'document_download.select_type' | translate}}</mat-label>
        <mat-select [placeholder]="'document_template.lbl_document_type' | translate" formControlName="itemTypeId"
          required>
          <mat-option>
            <ngx-mat-select-search [formControl]="searchTypeCtrl" placeholderLabel="Nhập loại hợp đồng/văn bản"
              [searching]="loadingSearchType" noEntriesFoundLabel="Không có kết quả!"></ngx-mat-select-search>
          </mat-option>
          <mat-option *ngFor="let type of listTypes | async" [value]="type.id">
            {{ type.name }}
          </mat-option>
        </mat-select>

        <mat-error *ngIf="formValue.controls.itemTypeId.hasError('required')">
          {{'document_download.type_required' | translate}}
        </mat-error>
      </mat-form-field>
    </div>
    <!-- content -->
    <div>
      <mat-form-field class="w-100">
        <mat-label>{{'document_download.description' | translate}}</mat-label>
        <textarea matInput formControlName="description" rows="3" maxlength="500" style="resize: none;"
          (focusout)="focusOut('description')"></textarea>
      </mat-form-field>
    </div>
    <span *ngIf="categoryList && categoryList.length">{{ "document_download.category_list" | translate }}:
      <span class="categoryList" *ngFor="let category of categoryList">{{category.name}}</span>
    </span>
  </form>

</mat-dialog-content>
<div mat-dialog-actions class="justify-content-center mt-2">
  <!--build icon, set default cancel-->
  <button mat-stroked-button color="primary" (click)="closeDialog()">
    <mat-icon class="mr-0">cancel</mat-icon>
    {{ "document_download.cancel" | translate }}
  </button>
  <button mat-raised-button color="primary" class="ml-2" (click)="onDownload()">
    <mat-icon class="mr-0">save_alt</mat-icon>
    {{ "document_download.download" | translate }}
  </button>
</div>
